module.exports = __webpack_public_path__ + "img/clogo.03a3fdad.png";